import { connect } from 'react-redux';
import AirportDeatils from './AirportDetails';
import { fetchAirportDetails } from '../../../actions/flight';

const mapStateToProps = state => ({
  airports: state.common.airports,
});

const mapDispatchToProps = dispatch => ({
  fetchAirportDetails: code => dispatch(fetchAirportDetails(code)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AirportDeatils);
